import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { OwlOptions, SlidesOutputData, CarouselModule } from 'ngx-owl-carousel-o';
import { Banner, ClickActionChoices } from 'src/app/home/models/home.model';
import { HorizontalBannerComponent } from './horizontal-banner/horizontal-banner.component';

const CAROUSEL_CONFIG: OwlOptions = {
  loop: true,
  margin: 10,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  autoplaySpeed: 2000,
  dotsSpeed: 500,
  autoplayMouseleaveTimeout: 5000,
  dots: false,
  smartSpeed: 400,
  dragEndSpeed: 350,
  stagePadding: 30,
  nav: false,
  responsive: {
    0: {
      items: 3
    },

    600: {
      items: 3
    },

    900: {
      items: 5
    },

    1295: {
      items: 5
    }
  },
};
@Component({
  standalone: true,
  selector: 'horizontal-banner-list',
  templateUrl: './horizontal-banner-list.component.html',
  styleUrls: ['./horizontal-banner-list.component.scss'],
  imports: [CommonModule, RouterModule, CarouselModule, HorizontalBannerComponent]
})
export class HorizontalBannerListComponent {

  @Input() set banners(banners: Banner[]) {
    if (Array.isArray(banners)) {
      this._banners = banners.filter(banner =>
        banner.images.some(image => image?.url
        ));
      if (banners.length < 5) {
        this._banners = [];
      } else {
        this.customOptions = CAROUSEL_CONFIG;
      }
    } else {
      this._banners = [];
    }
  }
  get banners(): Banner[] {
    return this._banners;
  }
  private _banners: Banner[] = [];

  @Input() title = '';
  @Input() isMultipleBanner = false;

  ClickActionChoices = ClickActionChoices;
  isDragging: boolean = false;
  startPosition: number = 0;

  customOptions: OwlOptions = CAROUSEL_CONFIG;

  translated(slidesOutputData: SlidesOutputData) {
    this.startPosition = slidesOutputData.startPosition || 0;
  }

  private makeCarouselAsImageViewer() {
    this.customOptions.loop = false;
  }

}



